import useSearchResults from './useSearchResults';
export default useSearchResults;
//# sourceMappingURL=index.js.map